// !need to disable linter or compile fails
// todo: move to using verge3d module.js
/* eslint-disable */

// import { passInstance } from '../verge3d/vergeLib.js'

var appInstance = null
var CONTAINER_ID = 'v3d-container-scroll'

function createApp(REL_URL_PREFIX, FILE_PATH, PUZZLES_ENABLED, BACKGROUND) {
  var LOAD_LOGIC_FILES = PUZZLES_ENABLED
  var params = v3d.AppUtils.getPageParams()

  var logicURL = params.logic
    ? params.logic
    : '__LOGIC__visual_logic.js'.replace('__LOGIC__', REL_URL_PREFIX)
  var sceneURL = params.load ? params.load : FILE_PATH
  if (!sceneURL) {
    console.log('No scene URL specified')
    return
  }

  // some puzzles can benefit from cache
  v3d.Cache.enabled = false

  if (LOAD_LOGIC_FILES) {
    new v3d.PuzzlesLoader().loadLogic(logicURL, function() {
      var initOptions = v3d.PL
        ? v3d.PL.execInitPuzzles({
            container: CONTAINER_ID
          }).initOptions
        : { useFullscreen: true }
      loadScene(sceneURL, initOptions, LOAD_LOGIC_FILES, BACKGROUND)
    })
  } else {
    return loadScene(
      sceneURL,
      { useFullscreen: true },
      LOAD_LOGIC_FILES,
      BACKGROUND
    )
  }
}

function loadScene(sceneURL, initOptions, load_with_puzzles, BACKGROUND) {
  // todo: refine these and pass options from component
  // Set Init Options
  initOptions.useBkgTransp = BACKGROUND
  initOptions.fadeAnnotations = true
  initOptions.preserveDrawBuf = false
  initOptions = initOptions || {}

  var ctxSettings = {}
  if (initOptions.useBkgTransp) ctxSettings.alpha = true
  if (initOptions.preserveDrawBuf) ctxSettings.preserveDrawingBuffer = true

  var preloader = initOptions.useCustomPreloader
    ? createCustomPreloader(
        initOptions.preloaderProgressCb,
        initOptions.preloaderEndCb
      )
    : new v3d.SimplePreloader({ container: CONTAINER_ID })

  var app = new v3d.App(CONTAINER_ID, ctxSettings, preloader)
  if (initOptions.useBkgTransp) {
    app.clearBkgOnLoad = true
    app.renderer.setClearColor(0x000000, 0)
  }
  appInstance = app

  if (initOptions.preloaderStartCb) initOptions.preloaderStartCb()

  if (load_with_puzzles) {
    app.loadScene(
      sceneURL,
      function() {
        app.enableControls()
        app.run()
        if (v3d.PL) v3d.PL.init(app, initOptions)
        appInstance = app
        runCode(app)
      },
      null,
      function() {
        console.log("Can't load the scene " + sceneURL)
      }
    )
  } else {
    return [app, sceneURL]
  }
}

function createCustomPreloader(updateCb, finishCb) {
  function CustomPreloader() {
    v3d.Preloader.call(this)
  }

  CustomPreloader.prototype = Object.assign(
    Object.create(v3d.Preloader.prototype),
    {
      onUpdate: function(percentage) {
        v3d.Preloader.prototype.onUpdate.call(this, percentage)
        if (updateCb) updateCb(percentage)
      },
      onFinish: function() {
        v3d.Preloader.prototype.onFinish.call(this)
        if (finishCb) finishCb()
      }
    }
  )

  return new CustomPreloader()
}

/**
 * Modify the app's preloader to track the loading process in the Puzzles Editor.
 */
function puzzlesEditorPreparePreloader(preloader) {
  // backward compatibility for loading new projects within the old Puzzles Editor
  if (
    v3d.PE.loadingUpdateCb !== undefined &&
    v3d.PE.loadingFinishCb !== undefined
  ) {
    var _onUpdate = preloader.onUpdate.bind(preloader)
    preloader.onUpdate = function(percentage) {
      _onUpdate(percentage)
      v3d.PE.loadingUpdateCb(percentage)
    }

    var _onFinish = preloader.onFinish.bind(preloader)
    preloader.onFinish = function() {
      _onFinish()
      v3d.PE.loadingFinishCb()
    }
  }
}

function runCode(app) {
  // passInstance(app)
}

// return verge app instance to get access to instance from vue
// when using puzzles app instance is not returned to vue due to async puzzle loader
function getAppInstance() {
  return appInstance
}

export { createApp, getAppInstance, CONTAINER_ID }
